<div
        class="layout-wrapper layout-static"
        [ngClass]="{
    'layout-static-inactive': layoutService.staticMenuInactive,
    'layout-mobile-active': layoutService.mobileMenuActive,
  }"
>
    <!-- Primo elemento raggiungibile da tastiera: senza, si attraversa tutto il
         menu a ogni cambio di pagina (WCAG 2.4.1). -->
    <a class="skip-link" href="#contenuto-principale" (click)="focusMainContent($event)">
      Vai al contenuto principale
    </a>

    <!-- Chiude il menu su mobile. È un comando, quindi un pulsante: un
         contenitore non viene annunciato né risponde a Invio (WCAG 2.1.1). -->
    <button
      type="button"
      class="layout-mask"
      aria-label="Chiudi il menu"
      (click)="layoutService.onMaskClick()"
    ></button>
    <app-topbar></app-topbar>
    <app-sidebar></app-sidebar>
    <app-main></app-main>
    <p-toast position="bottom-center" [life]="3200"/>
</div>
